import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AgentRulesCard } from '@apps/web/components/settings/agent_rules_card';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

const searchSchema = z.object({
    playbook: z.string().optional(),
    // Deep links from Slack and the admin agent-notes page carry the org so the
    // page opens in the note's org, matching the caregivers/clients links.
    // `mode` is accepted for parity with those routes; the note deep link omits
    // it.
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/playbooks')({
    component: PlaybooksPage,
    head: () => ({
        meta: [
            {
                title: 'Playbooks | Phoebe',
            },
        ],
    }),
    validateSearch: searchSchema,
});

function PlaybooksPage() {
    const {
        playbook: initialPlaybookId,
        organizationId: deepLinkOrganizationId,
        mode: deepLinkMode,
    } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );
    const organizationId = useOrganizationId();

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return (
        <div className="container mx-auto max-w-5xl p-6">
            <AgentRulesCard
                organizationId={organizationId}
                initialPlaybookId={initialPlaybookId ?? null}
            />
        </div>
    );
}
